var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-alert container"},[_c('div',{staticClass:"length mx-auto text-left"},[_c('el-alert',{attrs:{"title":_vm.message,"type":_vm.type,"description":_vm.description,"show-icon":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }